import script from "./SalesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesView.vue?vue&type=script&setup=true&lang=js"

import "./SalesView.vue?vue&type=style&index=0&id=d1a89eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a89eb4"]])

export default __exports__